import type { FilterSidebarToggleHandler } from "./filter-sidebar-toggle-handler";

const DISMISS_THRESHOLD_PX = 100;

export class FilterSidebarToggleListener {
    public constructor(private readonly handler: FilterSidebarToggleHandler) {}

    public registerToggle(
        el: HTMLElement,
        wrapper: HTMLElement,
        btn: HTMLElement | null,
        mobileBtn: HTMLElement | null,
    ): void {
        el.addEventListener("click", () => {
            this.handler.applyState(wrapper, btn, mobileBtn, !this.handler.isOpen(wrapper));
        });
    }

    // Backdrop tap → close (mobile only)
    public registerBackdropClose(wrapper: HTMLElement, btn: HTMLElement | null, mobileBtn: HTMLElement | null): void {
        wrapper.addEventListener("click", (e) => {
            if (this.handler.isMobile() && !(e.target as Element).closest(".filter-sidebar")) {
                this.handler.applyState(wrapper, btn, mobileBtn, false);
            }
        });
    }

    // Mobile bottom-sheet: drag the handle down to dismiss, or release early to snap back open.
    public registerDrag(
        dragHandle: HTMLElement,
        sidebar: HTMLElement,
        wrapper: HTMLElement,
        btn: HTMLElement | null,
        mobileBtn: HTMLElement | null,
    ): void {
        let dragging = false;
        let startY = 0;
        let dragDelta = 0;

        dragHandle.addEventListener("pointerdown", (e) => {
            if (!this.handler.isMobile()) return;
            dragging = true;
            startY = e.clientY;
            dragDelta = 0;
            this.handler.setSidebarTransitionOverride(sidebar, "none");
            dragHandle.setPointerCapture(e.pointerId);
        });

        dragHandle.addEventListener("pointermove", (e) => {
            if (!dragging) return;
            dragDelta = Math.max(0, e.clientY - startY);
            this.handler.setSidebarDragOffset(sidebar, dragDelta);
        });

        const endDrag = (e: PointerEvent): void => {
            if (!dragging) return;
            dragging = false;
            this.handler.setSidebarTransitionOverride(sidebar, null);
            this.handler.setSidebarDragOffset(sidebar, null);
            if (dragHandle.hasPointerCapture(e.pointerId)) {
                dragHandle.releasePointerCapture(e.pointerId);
            }
            if (dragDelta > DISMISS_THRESHOLD_PX) {
                this.handler.applyState(wrapper, btn, mobileBtn, false);
            }
            dragDelta = 0;
        };

        dragHandle.addEventListener("pointerup", endDrag);
        dragHandle.addEventListener("pointercancel", endDrag);
    }
}
